import { useMedia } from "@catchoftheday/theme";

type Sizes = "xs" | "sm" | "md" | "lg" | "xl";

type TilesPerBreakpoint = Record<Sizes, number>;

const defaultSlidesPerBreakpoint: TilesPerBreakpoint = {
  xs: 1,
  sm: 2,
  md: 3,
  lg: 4,
  xl: 5,
};

export const getRecommenderTilesPerBreakpoint = (
  tilesPerBreakpoint?: TilesPerBreakpoint
): [number, number, number, number, number] => {
  return [
    tilesPerBreakpoint?.xl || defaultSlidesPerBreakpoint.xl,
    tilesPerBreakpoint?.lg || defaultSlidesPerBreakpoint.lg,
    tilesPerBreakpoint?.md || defaultSlidesPerBreakpoint.md,
    tilesPerBreakpoint?.sm || defaultSlidesPerBreakpoint.sm,
    tilesPerBreakpoint?.xs || defaultSlidesPerBreakpoint.xs,
  ];
};

export const useVisibleRecommenderTiles = (
  tilesPerBreakpoint?: TilesPerBreakpoint
) =>
  useMedia<number>(
    [
      "(min-width: 1280px)",
      "(min-width: 1024px)",
      "(min-width: 768px)",
      "(min-width: 320px)",
      "(min-width: 0px)",
    ],
    getRecommenderTilesPerBreakpoint(tilesPerBreakpoint)
  ) || 0;
